import React from 'react';

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  customContent,
  type = 'info', // 'success', 'error', 'warning', 'info', 'confirm'
  confirmText = 'OK',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  showCancel = false
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Error notices keep a danger-tinted button; everything else is the one
  // primary action. `type` no longer draws an icon: the Forest dialog is
  // title, body, actions.
  const confirmClass = type === 'error' ? 'btn-danger' : 'btn-primary';

  return (
    <div
      className="fixed inset-0 bg-[color:var(--c-backdrop)] overflow-y-auto h-full w-full z-50 flex items-center justify-center"
      onClick={handleBackdropClick}
    >
      <div className="relative bg-white border border-gray-200 rounded-2xl shadow-lg max-w-md w-full mx-4">
        <div className="p-6">
          {title && (
            <h3 className="text-[17px] leading-6 font-semibold tracking-[-0.01em] text-gray-900">
              {title}
            </h3>
          )}

          {message && (
            <p className={`${title ? 'mt-1.5 ' : ''}text-[13px] text-gray-600`}>
              {message}
            </p>
          )}

          {customContent && (
            <div className="mt-4">
              {customContent}
            </div>
          )}

          <div className="mt-5 flex justify-end gap-2">
            {showCancel && (
              <button
                type="button"
                onClick={onCancel || onClose}
                className="btn-secondary"
              >
                {cancelText}
              </button>
            )}

            <button
              type="button"
              onClick={onConfirm || onClose}
              className={confirmClass}
              autoFocus
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;